import { API_BASE_URL } from "../config/apiConfig"

export const fetchCompanySiteBookingPermissions = async (token) => {
  if (!token) throw new Error("Company-site authentication token is missing")

  let response
  try {
    response = await fetch(`${API_BASE_URL}/sidebar/website-booking-permissions`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      cache: "no-store",
    })
  } catch (error) {
    throw new Error(`Booking permission service is unreachable: ${error.message}`)
  }

  let data
  try {
    data = await response.json()
  } catch (error) {
    throw new Error(`Permission API returned a non-JSON response (${response.status})`)
  }

  if (!response.ok) {
    throw new Error(data.message || data.error || `Permission request failed (${response.status})`)
  }
  if (!Array.isArray(data.data?.allowedTabs)) {
    throw new Error("Permission API did not return booking tabs")
  }

  return data.data
}

export const fetchCompanySiteMenu = async (token) => {
  if (!token) throw new Error("Company-site authentication token is missing")

  let response
  try {
    response = await fetch(`${API_BASE_URL}/sidebar`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      cache: "no-store",
    })
  } catch (error) {
    throw new Error(`Permission service is unreachable: ${error.message}`)
  }

  let data
  try {
    data = await response.json()
  } catch (error) {
    throw new Error(`Permission API returned a non-JSON response (${response.status})`)
  }

  if (!response.ok) {
    throw new Error(data.message || `Permission request failed (${response.status})`)
  }
  if (!data.data?.menu) {
    throw new Error("Permission API did not return a menu")
  }

  return data.data
}
